var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6464 11.6464C11.8417 11.4512 12.1583 11.4512 12.3536 11.6464L14.8536 14.1464C15.0488 14.3417 15.0488 14.6583 14.8536 14.8536C14.6583 15.0488 14.3417 15.0488 14.1464 14.8536L12.5 13.2071V21.5C12.5 21.7761 12.2761 22 12 22C11.7239 22 11.5 21.7761 11.5 21.5V13.2071L9.85355 14.8536C9.65829 15.0488 9.34171 15.0488 9.14645 14.8536C8.95118 14.6583 8.95118 14.3417 9.14645 14.1464L11.6464 11.6464Z",
    fill: "#717C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4547 16.9998L15.4449 16.9899C15.1976 16.9955 15 17.1976 15 17.445V17.5C15 17.7761 15.2239 18 15.5 18H16.5L16.5551 17.9997C19.5673 17.9702 22 15.5192 22 12.5C22 9.78305 20.03 7.52623 17.4404 7.08008C16.5452 5.25581 14.6692 4 12.5 4C9.98093 4 7.85741 5.69353 7.20586 8.00416C7.13758 8.0014 7.06895 8 7 8C4.23858 8 2 10.2386 2 13C2 15.7614 4.23858 18 7 18H8.5C8.77614 18 9 17.7761 9 17.5C9 17.2239 8.77614 17 8.5 17H7C4.79086 17 3 15.2091 3 13C3 10.7909 4.79086 9 7 9C7.05544 9 7.11058 9.00112 7.1654 9.00334L7.55975 9.01931C7.79097 9.02867 7.99841 8.87815 8.06121 8.65542L8.16832 8.27556C8.70156 6.38452 10.4404 5 12.5 5C14.2733 5 15.809 6.02566 16.5427 7.52064L16.6551 7.74977C16.7258 7.89368 16.8611 7.99501 17.0191 8.02223L17.2706 8.06556C19.3886 8.43047 21 10.2781 21 12.5C21 14.9853 18.9853 17 16.5 17L16.4547 16.9998Z",
    fill: "#717C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadNew);
export default __webpack_public_path__ + "static/media/Upload_new.f5b0f05fdabf511b81d2228977e45973.svg";
export { ForwardRef as ReactComponent };